module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.show) ? _c('div', {
    class: [_vm.center ? 'dof-noticebar-center' : 'dof-noticebar'],
    style: _vm.noticebarStyle,
    attrs: {
      "accessible": true,
      "ariaLabel": _vm.notice
    },
    on: {
      "click": _vm.noticeBarClicked
    }
  }, [_c('image', {
    staticClass: ["type-ICON"],
    staticStyle: {
      marginRight: "16px"
    },
    attrs: {
      "src": _vm.typeIcon
    }
  }), _c('text', {
    class: [_vm.center ? 'noticebar-content-center' : 'noticebar-content'],
    style: _vm.contentStyle
  }, [_vm._v(_vm._s(_vm.notice))]), (_vm.mode) ? _c('div', {
    staticClass: ["more-click-content"],
    attrs: {
      "mode": _vm.mode
    }
  }, [((this.mode == 'btn' && _vm.btnText) || this.mode == 'all') ? _c('text', {
    class: ['btnText', _vm.activeBtnText],
    style: _vm.btnTextStyle,
    on: {
      "click": _vm.noticeIconClicked
    }
  }, [_vm._v(_vm._s(_vm.btnText))]) : _vm._e(), (this.mode == 'all') ? _c('div', {
    staticStyle: {
      width: "8px"
    }
  }) : _vm._e(), _c('div', {
    staticClass: ["closeImg"]
  }, [(_vm._theme !== 'colmo' && ((_vm.modeIcon && this.mode == 'closable') || this.mode == 'all')) ? _c('image', {
    staticClass: ["mode-ICON"],
    style: {
      opacity: _vm._isDiablo ? 0.85 : 1
    },
    attrs: {
      "src": _vm.modeIcon
    },
    on: {
      "click": _vm.closeIconClicked
    }
  }) : (_vm._theme == 'colmo' && ((_vm.modeIcon && this.mode == 'closable') || this.mode == 'all')) ? _c('dof-iconfont', {
    attrs: {
      "code": '\u4725',
      "color": "rgba(255,255,255,0.80)",
      "size": "50"
    }
  }) : _vm._e(), ((_vm.modeIcon && this.mode == 'closable') || this.mode == 'all') ? _c('div', {
    staticClass: ["closeBox"],
    on: {
      "click": _vm.closeIconClicked
    }
  }) : _vm._e()], 1), _c('div', {
    staticClass: ["linkBox"]
  }, [(_vm._theme !== 'colmo' && _vm.linkIcon && this.mode == 'link') ? _c('image', {
    staticClass: ["mode-ICON"],
    attrs: {
      "src": _vm.linkIcon
    }
  }) : (_vm._theme === 'colmo' && _vm.linkIcon && this.mode == 'link') ? _c('dof-iconfont', {
    attrs: {
      "code": '\u4713',
      "color": "rgba(255,255,255,0.80)",
      "size": "50"
    }
  }) : _vm._e()], 1)]) : _vm._e()]) : _vm._e()
},staticRenderFns: []}
module.exports.render._withStripped = true


//////////////////
// WEBPACK FOOTER
// ./~/weex-vue-loader/lib/template-compiler.js?id=data-v-300644d8!./~/weex-vue-loader/lib/selector.js?type=template&index=0!./packages/dof-noticebar/index.vue
// module id = 588
// module chunks = 0 1